import {getCookie} from './api';
import urls from './urls';

export class CreemBillingError extends Error {
    constructor(code, status, payload = {}) {
        super(code || `HTTP ${status}`);
        this.name = 'CreemBillingError';
        this.code = code || 'request_failed';
        this.status = status;
        this.payload = payload;
    }
}

const parseResponse = async (response) => {
    try {
        return await response.json();
    } catch (error) {
        return {};
    }
};

const requestJson = async (url, {
    method = 'GET',
    payload = null,
    idempotencyKey = '',
} = {}) => {
    const headers = {
        'X-CSRFToken': getCookie('csrftoken'),
    };
    if (payload !== null) {
        headers['Content-Type'] = 'application/json';
    }
    if (idempotencyKey) {
        headers['Idempotency-Key'] = idempotencyKey;
    }
    const response = await fetch(url, {
        method,
        credentials: 'include',
        headers,
        body: payload === null ? null : JSON.stringify(payload),
    });
    const body = await parseResponse(response);
    if (!response.ok) {
        throw new CreemBillingError(body.code, response.status, body);
    }
    return body;
};

export const createIdempotencyKey = () => {
    if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
    }
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const getCreemCatalog = () => requestJson(urls.creemCatalog);

export const createCreemCheckout = (productCode, idempotencyKey) => requestJson(
    urls.creemCheckout,
    {
        method: 'POST',
        payload: {product_code: productCode},
        idempotencyKey,
    },
);

export const getCreemCheckoutStatus = (requestId) => requestJson(
    urls.creemCheckoutStatus(requestId),
);

export const getCreemSubscription = () => requestJson(urls.creemSubscription);

export const mutateCreemSubscription = (action, productCode, idempotencyKey) => {
    const payload = {action};
    if (productCode) {
        payload.product_code = productCode;
    }
    return requestJson(urls.creemSubscriptionMutation, {
        method: 'POST',
        payload,
        idempotencyKey,
    });
};

export const reconcileCreemSubscription = () => requestJson(
    urls.creemSubscriptionReconcile,
    {method: 'POST', payload: {}},
);

export const openCreemCustomerPortal = () => requestJson(
    urls.creemCustomerPortal,
    {method: 'POST', payload: {}},
);
